export const csvImport = (csv: string) => {
  const [headers, ...rest] = csv
    .split("\n")
    .filter((line) => line)
    .map((line) => line.split(";"));
  return rest.map((r) =>
    r.reduce((acc, col, idx) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      acc[headers[idx]] = col;
      return acc;
    }, {})
  );
};
